import 'foundation-sites/js/foundation/foundation';
import 'foundation-sites/js/foundation/foundation.dropdown';
import utils from '@bigcommerce/stencil-utils';
import Review from '../product/reviews';
import ProductDetails from '../common/product-details';
import { defaultModal, ModalEvents } from './modal';
import 'slick-carousel';
import { setCarouselState, onSlickCarouselChange, onUserCarouselChange } from '../common/carousel';

export default function (context) {
    const modal = defaultModal();

    $('body').on('click', '.quickview', event => {
        event.preventDefault();

        const productId = $(event.currentTarget).data('productId');
        const handleDropdownExpand = ({ currentTarget }) => {
            const $dropdownMenu = $(currentTarget);
            const dropdownBtnHeight = $dropdownMenu.prev().outerHeight();

            $dropdownMenu.css('top', dropdownBtnHeight);

            return modal.$modal.one(ModalEvents.close, () => $dropdownMenu.off('opened.fndtn.dropdown', handleDropdownExpand));
        };

        modal.open({ size: 'large' });

        // inject mpn related value to context for quick view
        fetch('/graphql', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + context.settings.storefront_api.token
            },
            body: JSON.stringify({
                query: `
                query getProduct {
                    site {
                    product (entityId: ` + productId + `) {
                        sku
                        mpn
                    }
                  }
                }
                `
            }),
        })
        .then(res => res.json())
        .then(json => {
            if (json.data.site.product) {
                let mpn = json.data.site.product.mpn;
                context.mpn = mpn;
                context.productId = productId;
                let music_video_product = 0;
                if (mpn) {
                    let split = mpn.split('-');
                    const type = split.pop();
                    const groupIds = ['V', 'L', 'VL'];
                    if (groupIds.includes(type)) {
                        music_video_product = 1;
                    }
                }
                context.music_video_product = music_video_product;

                // original quick view function
                utils.api.product.getById(productId, { template: 'products/quick-view' }, (err, response) => {
                    if (err) return;

                    modal.updateContent(response);

                    $('#modal .dropdown-menu').on('opened.fndtn.dropdown', handleDropdownExpand);
                    modal.$content.find('.productView').addClass('productView--quickView');

                    const $carousel = modal.$content.find('[data-slick]');
                    if ($carousel.length) {
                        $carousel.on('init breakpoint swipe', setCarouselState);
                        $carousel.on('click', '.slick-arrow, .slick-dots', setCarouselState);

                        $carousel.on('init afterChange', (e, carouselObj) => onSlickCarouselChange(e, carouselObj, context));
                        $carousel.on('click', '.slick-arrow, .slick-dots', $carousel, e => onUserCarouselChange(e, context));
                        $carousel.on('swipe', (e, carouselObj) => onUserCarouselChange(e, context, carouselObj.$slider));

                        if (modal.$modal.hasClass('open')) {
                            $carousel.slick();
                        } else {
                            modal.$modal.one(ModalEvents.opened, () => {
                                if ($.contains(document, $carousel[0])) $carousel.slick();
                            });
                        }
                    }

                    // remove add to cart on super easy order form
                    if ($('body').hasClass('super-easy-order-form')) {
                        modal.$content.find('form[data-cart-item-add]').remove();
                    }

                    // add vimeo video script inside quickview
                    $('.productView-thumbnail a img[title*="vimeo"]', modal.$content).before('<div class="prod-image-thumb-overlay"></div>');
                    $('.productView-thumbnail a img[title*="vimeo"]', modal.$content).parent().addClass('vimeo-video');
                    $('.productView-thumbnail a.vimeo-video', modal.$content).click(function(evt) {
                        evt.preventDefault();
                        var vimeoId = $(this).find('img[title*="vimeo"]').attr("title").split("/").pop();
                        $('.productView-images .prod-video-container-wrap', modal.$content).remove();
                        $('.productView-image', modal.$content).css('display', 'none');
                        $('.productView-image', modal.$content).before('<div class="prod-video-container-wrap"><div class="prod-video-container"><iframe src=https://player.vimeo.com/video/' + vimeoId + ' frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe></div></div>');
                    });
                    $('.productView-thumbnail a:not(.vimeo-video)', modal.$content).click(function() {
                        $('.productView-images .prod-video-container-wrap', modal.$content).remove();
                        $('.productView-image', modal.$content).css('display', 'block');
                    });

                    /* eslint-disable no-new */
                    new Review({ $context: modal.$content });

                    return new ProductDetails(modal.$content.find('.quickView'), context);
                });                
            }
        })


    });
}
